export var PrivateRequestStatus;
(function (PrivateRequestStatus) {
    PrivateRequestStatus["requested"] = "requested";
    PrivateRequestStatus["declined"] = "declined";
    PrivateRequestStatus["started"] = "started";
    PrivateRequestStatus["stopped"] = "stopped";
    PrivateRequestStatus["spy_leave"] = "spy_leave";
    PrivateRequestStatus["error"] = "error";
})(PrivateRequestStatus || (PrivateRequestStatus = {}));
export var BroadcastStatus;
(function (BroadcastStatus) {
    BroadcastStatus["Offline"] = "offline";
    BroadcastStatus["Connecting"] = "connecting";
    BroadcastStatus["Streaming"] = "streaming";
})(BroadcastStatus || (BroadcastStatus = {}));
export var StreamStatus;
(function (StreamStatus) {
    StreamStatus["Offline"] = "offline";
    StreamStatus["Public"] = "public";
    StreamStatus["Private"] = "private";
    StreamStatus["Hidden"] = "hidden";
    StreamStatus["Away"] = "away";
    StreamStatus["PasswordProtected"] = "passwordprotected";
    StreamStatus["Unknown"] = "unknown";
})(StreamStatus || (StreamStatus = {}));
